<template>
    <el-tabs type="border-card" @tab-click="SetData" v-model="Act">
      <el-tab-pane :label="item.system_name" :name="item.system_code" v-for="item in SystemList" :key="item.system_code">
            <ExpertScene v-if="Act == item.system_code" :ApiType='item.system_code'></ExpertScene>
      </el-tab-pane>
    </el-tabs>
</template>

<script>
    export default {
        data() {
            return {
                Act:"",
                SystemList:"",
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("ThisMenu"));
            this.Act = this.SystemList[0].system_code || "";
        },
        methods: {
            SetData(tab) {
                this.Act = tab.name;
                this.SystemList.forEach((item) => {
                    if (item.system_code == tab.name) {
                        this.$parent.SetExpertMenu(item.cd_list);
                    }
                });
            },
        },
    }
</script>

<style>
</style>